function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { nanoid } from "./util";
import { SignalType } from "./signal";
export var PeerSignal = /*#__PURE__*/ function() {
    "use strict";
    function PeerSignal(socket, peerID) {
        var jc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
            noPublish: false,
            noSubscribe: false
        };
        _classCallCheck(this, PeerSignal);
        this._socket = socket;
        this._peerID = peerID;
        this._jc = jc;
        this._socket.addMessageListener(this._handleSocketMessage.bind(this));
    }
    var _proto = PeerSignal.prototype;
    _proto._handleSocketMessage = function _handleSocketMessage(event) {
        var s = JSON.parse(event.data);
        if (s.type === SignalType.PeerOffer) {
            var so = s;
            if (so.peerID !== this._peerID) {
                // console.log('peer ids for offer dont match', so.peerID, this._peerID);
                return;
            }
            if (this.onnegotiate) this.onnegotiate(so.offer);
        } else if (s.type === SignalType.PeerTrickle) {
            var st = s;
            if (st.peerID !== this._peerID) {
                // console.log('peer ids for trickle dont match', st.peerID, this._peerID);
                return;
            }
            var trickle = {
                candidate: st.candidate,
                target: st.target
            };
            if (this.ontrickle) this.ontrickle(trickle);
        }
    };
    _proto._createPeer = function _createPeer() {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var id, s;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = nanoid();
                        s = {
                            type: SignalType.PeerCreate,
                            id: id,
                            peerID: _this._peerID
                        };
                        return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                            _this._socket.syncSend(s).then(function(_) {
                                resolve();
                            }).catch(reject);
                        }));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto._closePeer = function _closePeer() {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var id, s;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = nanoid();
                        s = {
                            type: SignalType.PeerClose,
                            id: id,
                            peerID: _this._peerID
                        };
                        return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                            _this._socket.syncSend(s).then(function(_) {
                                resolve();
                            }).catch(reject);
                        }));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.join = function join(sid, uid, offer) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this._createPeer();
                    case 2:
                        return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                            var id = nanoid();
                            var s1 = {
                                type: SignalType.PeerJoin,
                                id: id,
                                peerID: _this._peerID,
                                sid: sid,
                                offer: offer,
                                config: _this._jc
                            };
                            _this._socket.syncSend(s1).then(function(s) {
                                resolve(s.offer);
                            }).catch(reject);
                        }));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.trickle = function trickle1(trickle) {
        var s = {
            type: SignalType.PeerTrickle,
            peerID: this._peerID,
            target: trickle.target,
            candidate: trickle.candidate
        };
        this._socket.send(s);
    };
    _proto.offer = function offer1(offer) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var id, s2;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = nanoid();
                        s2 = {
                            type: SignalType.PeerOffer,
                            id: id,
                            peerID: _this._peerID,
                            offer: offer
                        };
                        return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                            _this._socket.syncSend(s2).then(function(s) {
                                resolve(s.offer);
                            }).catch(reject);
                        }));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.answer = function answer1(answer) {
        var s = {
            type: SignalType.PeerAnswer,
            peerID: this._peerID,
            offer: answer
        };
        this._socket.send(s);
    };
    _proto.close = function close() {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this._socket.removeMessageListener(_this._handleSocketMessage.bind(_this));
                        _ctx.next = 3;
                        return _this._closePeer();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _createClass(PeerSignal, [
        {
            key: "peerID",
            set: function set(peerID) {
                this._peerID = peerID;
            }
        }
    ]);
    return PeerSignal;
}();
